module.exports = __webpack_public_path__ + "img/blue_034.1cd94455.png";